import React from 'react';
import { connect } from 'react-redux'
import NuevaSolicitudDatos from './NuevaSolicitudDatos.jsx';

//Importación de actions.
//import
//{

//} from '../actions/Actions';


const mapStateToProps = (state) => {
  return {
     
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
      
  }
}

//Connect entre el componente y las props y actions.
const NuevaSolicitudDatosContainer = connect(mapStateToProps, mapDispatchToProps)(NuevaSolicitudDatos);

export default NuevaSolicitudDatosContainer;